module.exports = __webpack_public_path__ + "static/img/lg-ess-img-02-03@m.e5eebbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-02-03@m.jpg
// module id = mH+T
// module chunks = 0